import { mutate } from "swr";

import * as fetcher from "../fetcher";

export interface SendOpportunityEmailPayload {
  to: string[];
  cc?: string[];
  subject: string;
  bodyHtml: string;
  attachmentIds?: number[];
}

export const sendCommunication = async (
  projectId: number,
  payload: SendOpportunityEmailPayload
) => {
  if (!projectId) {
    return null;
  }
  try {
    const res = await fetcher.core.post(
      `/opportunities/communication/${projectId}/email`,
      payload
    );
    mutate(`/communication/${projectId}/email`);

    return res;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to send communication:", error);
  }
};
